import { SYSTEM_ERROR_TYPE } from '../../common/const';
import {
  SET_SYSTEM_ERROR_TYPE, SET_SYSTEM_LOADING_FLG,
  SET_SYSTEM_PROGRESS_FLG, SET_PROGRESS_VAL,
  SET_NETWORK_SPEED, SET_MESSAGE_AREA,
  SET_AUTH_ERROR_FLG,
  SET_MULTI_LOGIN_FLG,
  SET_USER_INFO, SET_CONTRACT_LABEL, SET_INFLOW_TYPE,
  SET_ERR_POP_MSG, SET_CONFIRM_POP_FLG, SET_PASSWORD_POP_FLG,
  SET_POP_MESSAGE, SET_CONFIRM_FLG,
  SET_ONCLICK_NO_FUNCTION, SET_ONCLICK_YES_FUNCTION,
  SET_DISP_ITEM,
} from '../actions/CommonAction';

const initState = {
  systemErrorType: SYSTEM_ERROR_TYPE.SUCCESS,
  systemLodingFLg: false,
  systemProgressFLg: false,
  progressVal: 0,
  networkSpeed: '0',
  infoMessages: [],
  warnMessages: [],
  errorMessages: [],
  // 認証エラーフラグ
  authErrorFlg: false,
  // 多重ログインエラーフラグ
  multiLoginFlg: false,
  // ユーザー情報
  userInfo: null,
  // 契約ラベル
  contractLabel: null,
  // 取得項目
  dispItem: null,
  // 処理区分
  inflowType: null,
  // 元のパスワード
  oldPassword: null,
  // 新規パスワード
  newPassword: null,
  // 新規パスワード(確認用)
  newPasswordConfim: null,
  // 元のパスワードエラーメッセージ
  errOldPassword: null,
  // 新規パスワードエラーメッセージ
  errNewPassword: null,
  // 新規パスワード(確認用)エラーメッセージ
  errNewPasswordConfirm: null,
  // パスワードPOPUPエラーメッセージ
  errPopMsg: null,
  // 確認POPUP表示フラグ
  confirmPopFlg: false,
  // パスワード変更POPUP表示フラグ
  passwordPopFlg: false,
  // POPUPのメッセージ
  popMessage: null,
  // 元のパスワードエラーフラグ
  errOldPasswordFlg: false,
  // 新規パスワードエラーフラグ
  errNewPasswordFlg: false,
  // 新規パスワード(確認用)エラーフラグ
  errNewPasswordConfirmFlg: false,
  // 確認POPUP「はい」選択時の呼出関数
  onClickYesFunction: null,
  // 確認POPUP「いいえ」選択時の呼出関数
  onClickNoFunction: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_SYSTEM_ERROR_TYPE:
      return { ...state, systemErrorType: action.systemErrorType };
    case SET_SYSTEM_LOADING_FLG:
      return { ...state, systemLodingFLg: action.systemLodingFLg };
    case SET_SYSTEM_PROGRESS_FLG:
      return { ...state, systemProgressFLg: action.systemProgressFLg };
    case SET_PROGRESS_VAL:
      return { ...state, progressVal: action.progressVal };
    case SET_NETWORK_SPEED:
      return { ...state, networkSpeed: action.networkSpeed };
    case SET_MESSAGE_AREA:
      return {
        ...state,
        infoMessages: action.infoMessages,
        warnMessages: action.warnMessages,
        errorMessages: action.errorMessages,
      };
    case SET_AUTH_ERROR_FLG:
      return { ...state, authErrorFlg: action.authErrorFlg };
    case SET_MULTI_LOGIN_FLG:
      return { ...state, multiLoginFlg: action.multiLoginFlg };
    case SET_USER_INFO:
      return { ...state, userInfo: action.userInfo };
    case SET_CONTRACT_LABEL:
      return { ...state, contractLabel: action.contractLabel };
    case SET_DISP_ITEM:
      return { ...state, dispItem: action.dispItem };
    case SET_INFLOW_TYPE:
      return { ...state, inflowType: action.inflowType };
    case SET_ERR_POP_MSG:
      return { ...state, errPopMsg: action.errPopMsg };
    case SET_CONFIRM_POP_FLG:
      return { ...state, confirmPopFlg: action.confirmPopFlg };
    case SET_PASSWORD_POP_FLG:
      return { ...state, passwordPopFlg: action.passwordPopFlg };
    case SET_POP_MESSAGE:
      return { ...state, popMessage: action.popMessage };
    case SET_CONFIRM_FLG:
      return { ...state, confirmFlg: action.confirmFlg };
    case SET_ONCLICK_YES_FUNCTION:
      return { ...state, onClickYesFunction: action.onClickYesFunction };
    case SET_ONCLICK_NO_FUNCTION:
      return { ...state, onClickNoFunction: action.onClickNoFunction };
    default:
      return state;
  }
};
